import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 31.9 40.7",
	style: { enableBackground: "new 0 0 31.9 40.7" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		className: "st0",
		d: "M21.6,0H10.3C9.6,0,9,0.6,9,1.2v2.3H0v4.2h31.9V3.5h-9V1.2C22.9,0.6,22.3,0,21.6,0z M30,10.2H2V37 c0,2,1.6,3.7,3.7,3.7h20.7c2,0,3.7-1.6,3.7-3.7V10.2H30z"
	})
});
export default SvgIconTrash;
